import React, { useState } from 'react';
import { auth } from '../config/firebaseConfig'; // Firebase auth'u import et
import { createUserWithEmailAndPassword } from 'firebase/auth'; // Kullanıcı oluşturma fonksiyonu

const KullaniciEkle = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    if (!email || !password) {
      setError('E-posta ve şifre gereklidir.');
      setLoading(false);
      return;
    }

    try {
      // Firebase Authentication ile kullanıcı oluşturma
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      setSuccess('Kullanıcı başarıyla oluşturuldu!');
      setEmail('');
      setPassword('');
    } catch (error) {
      setError('Bir hata oluştu: ' + error.message);
    }
    setLoading(false);
  };

  return (
    <div className="container-fluid">
      <h1 className="h3 mb-4 text-gray-800">Kullanıcı Oluştur</h1>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">Yeni Kullanıcı Ekle</h6>
        </div>
        <div className="card-body">
          {error && <div className="alert alert-danger">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">E-posta</label>
              <input
                type="email"
                className="form-control"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="E-posta adresini girin"
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Şifre</label>
              <input
                type="password"
                className="form-control"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Şifrenizi girin"
              />
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Yükleniyor...' : 'Kullanıcı Oluştur'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default KullaniciEkle;
